import { Api } from '../../Api';
import { MainPage } from '../MainPage';
import {
  PlatformApp,
  useLocation,
  useNavigate,
  User,
} from '@platform/cj-platform-navigation';
import '@cjdev-internal/design-tokens';
import { useEffect } from 'react';
import { PartnershipPage } from 'Components/PartnershipPage';

// design tokens are css variables that VSX depends on
export type AppDependencies = {
  api: Api;
  doc: Document;
};

export const App = (dependencies: AppDependencies) => {
  const layout = {
    filters: true,
    sidenav: true,
    dimensions: true,
    pageTitle: true,
    Buttons: true,
  };

  const routes = [
    {
      layout,
      path: '/',
      titleMessage: {
        id: 'nav-home',
        defaultMessage: 'Home',
      },
      Content: () => {
        const navigate = useNavigate();
        useEffect(() => {
          navigate('/list');
        }, [navigate]);
        return <></>;
      },
    },
    {
      layout,
      path: '/list',
      Buttons: () => <span id="createTagButton"></span>,
      titleMessage: {
        id: 'nav-root',
        defaultMessage: 'Tag Management',
      },
      Content: ({ user }: { user: User }) => {
        const { state } = useLocation();
        return (
          <MainPage
            api={dependencies.api}
            doc={dependencies.doc}
            user={user}
            savedPartners={state || []}
          />
        );
      },
    },
    {
      layout,
      path: '/:tagId/partnerships',
      titleMessage: {
        id: 'nav-partnership',
        defaultMessage: 'Partnership Management',
      },
      Content: ({ user }: { user: User }) => {
        const { state } = useLocation();
        return (
          <PartnershipPage
            api={dependencies.api}
            doc={dependencies.doc}
            user={user}
            existingPartnerships={{ ...state }}
          ></PartnershipPage>
        );
      },
    },
  ];

  const translations = {};
  return (
    <>
      <PlatformApp routes={routes} translations={translations} />
    </>
  );
};
